import { createLucideIcon } from 'lucide-react'

export const ExcludeCellIcon = createLucideIcon('exclude-cell', [
	[
		'path',
		{
			d: 'M 1.7 12.1 L 7.1 21.7',
			key: '79pdbx',
		},
	],
	[
		'path',
		{
			d: 'M 17 2.5 L 7.1 2.5',
			key: '1dnyza',
		},
	],
	[
		'path',
		{
			d: 'M 17 21.7 L 22.3 12',
			key: '5jfaih',
		},
	],
	[
		'path',
		{
			d: 'M 18 12 L 6 12',
			key: '13x4w8',
		},
	],
	[
		'path',
		{
			d: 'M 22.3 12 C22.3 11.9 18.5 5.1 17 2.5',
			key: '14bkmn',
		},
	],
	[
		'path',
		{
			d: 'M 7.1 2.5 L 1.7 12.1',
			key: '175clm',
		},
	],
	[
		'path',
		{
			d: 'M 7.1 21.7 L 17 21.7',
			key: '77mt11',
		},
	],
])
